import { map, set } from 'lodash/fp'
import { DataIngestor } from '~/api/onPremAgent/dataIngestorsAPI'
import Table from '~/components/Table'
import {
  getInstrumentCategory,
  getInstrumentImage,
  INSTRUMENT_DISPLAY_NAMES,
} from '~/utils/instrument'
import { renderStatusPill } from '~/utils/statusPill'
import cs from './data_ingestors_table.scss'

interface DataIngestorRow extends DataIngestor {
  _link: string
}

const DATA_INGESTOR_STATUS_CONFIG = {
  live: { type: 'accent' },
  off: { type: 'default' },
  paused: { type: 'inactive' },
  error: { type: 'error' },
}

const renderInstrumentName = (row: DataIngestorRow) => {
  return (
    <div className={cs.instrumentNameContainer}>
      <img
        className={cs.instrumentImage}
        src={getInstrumentImage({
          instrumentType: row.instrument_type,
          instrumentName: '',
        })}
      />
      <span className={cs.instrumentName}>{row.instrument_name}</span>
    </div>
  )
}

const renderInstrumentType = (row: DataIngestorRow) => {
  return (
    <div className={cs.instrumentType}>
      {INSTRUMENT_DISPLAY_NAMES[row.instrument_type]} &middot;{' '}
      {getInstrumentCategory({
        instrumentType: row.instrument_type,
        instrumentName: '',
      })}
    </div>
  )
}

const renderStatus = (status: 'live' | 'off' | 'paused' | 'error') => {
  return renderStatusPill(status, DATA_INGESTOR_STATUS_CONFIG, {})
}

const tableColumns = [
  {
    name: 'Instrument Name',
    width: 300,
    render: (row: DataIngestorRow) => renderInstrumentName(row),
  },
  {
    name: 'Instrument Type',
    width: 300,
    render: (row: DataIngestorRow) => renderInstrumentType(row),
  },
  {
    name: 'Status',
    width: 150,
    render: (row: DataIngestorRow) => renderStatus(row.status),
    verticalCenter: true,
  },
]

export default function DataIngestorsTable(props: { dataIngestors: DataIngestor[] }) {
  const dataIngestorRows = map(
    dataIngestor => set('_link', `/data-ingestors/${dataIngestor.uuid}`, dataIngestor),
    props.dataIngestors,
  ) as DataIngestorRow[]
  return (
    <Table<DataIngestorRow>
      columns={tableColumns}
      data={dataIngestorRows}
      rowKey='id'
      rowLeftRightPaddingVariant='rowPaddingNormal'
      headerTopBottomPaddingVariant='headerTopBottomPaddingEqual'
      heightSizing='default'
      stickyHeaders
    />
  )
}
